import { render, staticRenderFns } from "./phoneFooter.vue?vue&type=template&id=328ba5a5&scoped=true&"
import script from "./phoneFooter.vue?vue&type=script&lang=js&"
export * from "./phoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./phoneFooter.vue?vue&type=style&index=0&id=328ba5a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ba5a5",
  null
  
)

export default component.exports